module.exports = __webpack_public_path__ + "img/live.5f46de4c.gif";